/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Gate режима
 */

/**
 * Сервис управления Gate режимом
 */
export class GateModeServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения Gate режима
   */
  GetGateMode = (req?: GetGateModeRequestDto, init?: RequestInit): Promise<GetGateModeResponseDto> => {
    return fm.request<GetGateModeRequestDto, GetGateModeResponseDto>(`${this.host}/device/api/v1/gate/mode${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования Gate режима
   */
  SaveGateMode = (req: SaveGateModeRequestDto, init?: RequestInit): Promise<SaveGateModeResponseDto> => {
    return fm.request<SaveGateModeRequestDto, SaveGateModeResponseDto>(`${this.host}/device/api/v1/gate/mode`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Варианты подстановки номера дома и квартиры в SIP Invite
 */
export enum HouseInviteTemplateType {
  /**
   * Значение не указано
   */
  INVITE_TEMPLATE_TYPE_UNKNOWN = "INVITE_TEMPLATE_TYPE_UNKNOWN",
  /**
   * 4 символа для номера дома с лидирующими нулями, 4 символа для номера квартиры с лидирующими нулями.
   * Номера дома и квартиры при звонке подставляются в виде: 00120123@sip.acme.io
   */
  H4LZ_F4LZ = "H4LZ_F4LZ",
  /**
   * 4 символа для номера дома с лидирующими нулями, 4 или меньше символа для номера квартиры.
   * Номера дома и квартиры при звонке подставляются в виде: 0012123@sip.acme.io
   */
  H4LZ_F4 = "H4LZ_F4",
  /**
   * 4 или меньше символа для номера дома, 4 символа для номера квартиры с лидирующими нулями.
   * Номера дома и квартиры при звонке подставляются в виде: 120123@sip.acme.io
   */
  H4_F4LZ = "H4_F4LZ",
}
/**
 * Варианты подстановки номера дома и квартиры в SIP Invite
 */
export type HouseInviteTemplateTypeResponseEnum = keyof typeof HouseInviteTemplateType
/**
 * Варианты подстановки номера дома и квартиры в SIP Invite
 */
export type HouseInviteTemplateTypeRequestEnum = Exclude<HouseInviteTemplateTypeResponseEnum, "INVITE_TEMPLATE_TYPE_UNKNOWN">;

/**
 * Настройки Gate режима
 */
export type GateModeRequestDto = {
  /**
   * Флаг включения Gate режима.
   * true=gate; false=ordinary
   */
  isGateModeOn?: boolean
  /**
   * Дома Gate режима.
   * При редактировании массив полностью заменяется на отправленный
   */
  houses?: HouseRequestDto[]
}
/**
 * Настройки Gate режима
 */
export type GateModeResponseDto = {
  /**
   * Флаг включения Gate режима.
   * true=gate; false=ordinary
   */
  isGateModeOn: boolean
  /**
   * Дома Gate режима.
   * При редактировании массив полностью заменяется на отправленный
   */
  houses: HouseResponseDto[]
}
/**
 * Запрос получения Gate режима
 */
export type GetGateModeRequestDto = {
}
/**
 * Ответ на запрос получения Gate режима
 */
export type GetGateModeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Gate режима
   */
  readonly data: GateModeResponseDto
}>
/**
 * Дом Gate режима
 */
export type HouseRequestDto = {
  /**
   * Адрес дома
   */
  address: string
  /**
   * Номер дома (подъезда)
   */
  prefix: string
  /**
   * Диапазон квартир.
   * Если не задан, то устройство позволяет набор любой квартиры
   */
  roomRange?: HouseRoomRangeRequestDto | null
  /**
   * Адрес Sip сервера.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer?: string
  /**
   * Вариант подстановки номера дома и квартиры в SIP Invite.
   * При отсутствии значения используется вариант H4LZ_F4LZ
   */
  inviteTemplateType?: HouseInviteTemplateTypeRequestEnum | "INVITE_TEMPLATE_TYPE_UNKNOWN"
}
/**
 * Дом Gate режима
 */
export type HouseResponseDto = {
  /**
   * Адрес дома
   */
  address: string
  /**
   * Номер дома (подъезда)
   */
  prefix: string
  /**
   * Диапазон квартир.
   * Если не задан, то устройство позволяет набор любой квартиры
   */
  roomRange: HouseRoomRangeResponseDto | null
  /**
   * Адрес Sip сервера.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer: string
  /**
   * Вариант подстановки номера дома и квартиры в SIP Invite.
   * При отсутствии значения используется вариант H4LZ_F4LZ
   */
  inviteTemplateType: HouseInviteTemplateTypeResponseEnum
}
/**
 * Диапазон квартир
 */
export type HouseRoomRangeRequestDto = {
  /**
   * Начало диапазона включительно
   */
  firstRoomNumber: string
  /**
   * Конец диапазона включительно
   */
  lastRoomNumber: string
}
/**
 * Диапазон квартир
 */
export type HouseRoomRangeResponseDto = {
  /**
   * Начало диапазона включительно
   */
  firstRoomNumber: string
  /**
   * Конец диапазона включительно
   */
  lastRoomNumber: string
}
/**
 * Запрос редактирования Gate режима
 */
export type SaveGateModeRequestDto = {
  /**
   * Настройки Gate режима
   */
  data: GateModeRequestDto
}
/**
 * Ответ на запрос редактирования Gate режима
 */
export type SaveGateModeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Gate режима
   */
  readonly data: GateModeResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveGateModeResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveGateModeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveGateModeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Настройки Gate режима
   */
  "GateMode": {
    "kind": "class",
    "text": "Настройки Gate режима",
    "fields": {
      /**
       * Флаг включения Gate режима.
       * true=gate; false=ordinary
       */
      "isGateModeOn": {
        "type": "bool",
        "text": "Флаг включения Gate режима.\ntrue=gate; false=ordinary",
      },
      /**
       * Дома Gate режима.
       * При редактировании массив полностью заменяется на отправленный
       */
      "houses": {
        "type": "House",
        "text": "Дома Gate режима.\nПри редактировании массив полностью заменяется на отправленный",
      },
    },
  },
  /**
   * Запрос получения Gate режима
   */
  "GetGateModeRequest": {
    "kind": "class",
    "text": "Запрос получения Gate режима",
  },
  /**
   * Ответ на запрос получения Gate режима
   */
  "GetGateModeResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения Gate режима",
    "fields": {
      /**
       * Настройки Gate режима
       */
      "data": {
        "type": "GateMode",
        "text": "Настройки Gate режима",
      },
    },
  },
  /**
   * Дом Gate режима
   */
  "House": {
    "kind": "class",
    "text": "Дом Gate режима",
    "fields": {
      /**
       * Адрес дома
       */
      "address": {
        "type": "string",
        "text": "Адрес дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер дома (подъезда)
       */
      "prefix": {
        "type": "string",
        "text": "Номер дома (подъезда)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Диапазон квартир.
       * Если не задан, то устройство позволяет набор любой квартиры
       */
      "roomRange": {
        "type": "House.RoomRange",
        "text": "Диапазон квартир.\nЕсли не задан, то устройство позволяет набор любой квартиры",
      },
      /**
       * Адрес Sip сервера.
       * При пустом sip_server будет использован сервер SIP регистрации
       */
      "sipServer": {
        "type": "string",
        "text": "Адрес Sip сервера.\nПри пустом sip_server будет использован сервер SIP регистрации",
      },
      /**
       * Вариант подстановки номера дома и квартиры в SIP Invite.
       * При отсутствии значения используется вариант H4LZ_F4LZ
       */
      "inviteTemplateType": {
        "type": "House.InviteTemplateType",
        "text": "Вариант подстановки номера дома и квартиры в SIP Invite.\nПри отсутствии значения используется вариант H4LZ_F4LZ",
      },
    },
  },
  /**
   * Диапазон квартир
   */
  "House.RoomRange": {
    "kind": "class",
    "text": "Диапазон квартир",
    "fields": {
      /**
       * Начало диапазона включительно
       */
      "firstRoomNumber": {
        "type": "string",
        "text": "Начало диапазона включительно",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Конец диапазона включительно
       */
      "lastRoomNumber": {
        "type": "string",
        "text": "Конец диапазона включительно",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос редактирования Gate режима
   */
  "SaveGateModeRequest": {
    "kind": "class",
    "text": "Запрос редактирования Gate режима",
    "fields": {
      /**
       * Настройки Gate режима
       */
      "data": {
        "type": "GateMode",
        "text": "Настройки Gate режима",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос редактирования Gate режима
   */
  "SaveGateModeResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования Gate режима",
    "fields": {
      /**
       * Настройки Gate режима
       */
      "data": {
        "type": "GateMode",
        "text": "Настройки Gate режима",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveGateModeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveGateModeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Варианты подстановки номера дома и квартиры в SIP Invite
   */
  "House.InviteTemplateType": {
    "kind": "enum",
    "text": "Варианты подстановки номера дома и квартиры в SIP Invite",
    "values": {
      /**
       * Значение не указано
       */
      "INVITE_TEMPLATE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * 4 символа для номера дома с лидирующими нулями, 4 символа для номера квартиры с лидирующими нулями.
       * Номера дома и квартиры при звонке подставляются в виде: 00120123@sip.acme.io
       */
      "H4LZ_F4LZ": {
        "i": 1,
        "text": "4 символа для номера дома с лидирующими нулями, 4 символа для номера квартиры с лидирующими нулями.\nНомера дома и квартиры при звонке подставляются в виде: 00120123@sip.acme.io",
      },
      /**
       * 4 символа для номера дома с лидирующими нулями, 4 или меньше символа для номера квартиры.
       * Номера дома и квартиры при звонке подставляются в виде: 0012123@sip.acme.io
       */
      "H4LZ_F4": {
        "i": 2,
        "text": "4 символа для номера дома с лидирующими нулями, 4 или меньше символа для номера квартиры.\nНомера дома и квартиры при звонке подставляются в виде: 0012123@sip.acme.io",
      },
      /**
       * 4 или меньше символа для номера дома, 4 символа для номера квартиры с лидирующими нулями.
       * Номера дома и квартиры при звонке подставляются в виде: 120123@sip.acme.io
       */
      "H4_F4LZ": {
        "i": 3,
        "text": "4 или меньше символа для номера дома, 4 символа для номера квартиры с лидирующими нулями.\nНомера дома и квартиры при звонке подставляются в виде: 120123@sip.acme.io",
      },
    },
  },
}